export const LOCAL_STORAGE_API_KEY = 'bs_api'

export const LOCAL_STORAGE_WIZARD_UUID_KEY = 'bs_wizard_uuid'

export const LOCAL_STORAGE_MAILS_ACTIVE_ACCOUNT_KEY = 'bs_mails_active_account'

export const LOCAL_STORAGE_MENU_COLLAPSED_KEY = 'bs_menu-collapsed'

export const LOCAL_STORAGE_MASS_MAILING_FROM_CREATE = 'bs_from_create'

export const LOCAL_STORAGE_REAUTH_EMAIL = 'bs_hide_reauth_ts'

export const LOCAL_STORAGE_DOC_FLOW_COMBINING_PHASE_ASYNC_ACTION_IN_PROGRESS =
  'bs_doc_stapling_combining_phase_disable'

export const LOCAL_STORAGE_NAME_TOKEN = 'bs_token'

export const LOCAL_STORAGE_NAME_JWT_ACCESS = 'bs_jwt_access_token'

export const LOCAL_STORAGE_NAME_JWT_ACCESS_EXPIRATION_TIME =
  'bs_jwt_access_token_ts'

export const LOCAL_STORAGE_NAME_JWT_REFRESH = 'bs_jwt_refresh_token'

export const LOCAL_STORAGE_DRAFTS_KEY = 'bs_drafts'

export const STORAGE_EVENT = 'storage'

export const LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY =
  'bs_idwell_to_idwell_outbound_company_uuid'

export const LOCAL_STORAGE_REQUEST_CLOSE_CONFIRMATION_DISABLED_KEY =
  'bs_request_close_confirmation_disabled'

export const LOCAL_STORAGE_RECIPIENT_EMAIL_FIELD_AUTO_ADD_ADDITIONAL_CONTACTS =
  'bs_recipient_email_field_auto_add_additional_contacts'

export const LOCAL_STORAGE_GRETA_AI_CHAT_DRAFTS_KEY = 'bs_greta_ai_chat_drafts'

export const LOCAL_STORAGE_GRETA_AI_CHAT_PANEL_KEY = 'bs_greta_ai_chat_panel'

export const LOCAL_STORAGE_BIRDVIEW_LAYOUT_KEY = 'bs_birdview_layout'

export const LOCAL_STORAGE_BIRDVIEW_TILES_ORDER_KEY = 'bs_birdview_tiles_order'

export const LOCAL_STORAGE_BIRDVIEW_CHARTS_ORDER_KEY =
  'bs_birdview_charts_order'

export const LOCAL_STORAGE_BIRDVIEW_CHARTS_COLUMN_SPANS_KEY =
  'bs_birdview_charts_column_spans'

export const LOCAL_STORAGE_BIRDVIEW_CHARTS_ROW_SPANS_KEY =
  'bs_birdview_charts_row_spans'

export const LOCAL_STORAGE_BIRDVIEW_CHARTS_HIDDEN_KEY =
  'bs_birdview_charts_hidden'

export const LOCAL_STORAGE_BIRDVIEW_KPIS_ORDER_KEY = 'bs_birdview_kpis_order'

export const LOCAL_STORAGE_BIRDVIEW_CHART_CONTROLS_KEY =
  'bs_birdview_chart_controls'

export const LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_KPIS_ORDER_KEY =
  'bs_rental_portal_overview_kpis_order'

export const LOCAL_STORAGE_RENTAL_PORTAL_OVERVIEW_PANELS_LAYOUT_KEY =
  'bs_rental_portal_overview_panels_layout'

export const LOCAL_STORAGE_NEWSBOARD_POST_FILE_DELETE_CONFIRMATION_DISABLED_KEY =
  'bs_newsboard_post_file_delete_confirmation_disabled'

// Also read by public/theme-mode.js before the first paint.
export const LOCAL_STORAGE_THEME_MODE_KEY = 'bs_theme_mode'
